<template>
<div class="wrapper" :class="wrapperStyle.class">
  <div class="card">
    <div class="card-content">
    <p> 
    <label>
      <input
        :disabled="isDisabled"
        :id="`${name}_complete_field`"
        type="checkbox"
        v-model="fieldValue"
      />
      <span
        >Are you finished with this section? If so, check this box so we can help you track your progress in completing your Assessment. If you are not complete, leave unchecked. Feel free to move on and return to complete this section later.
        </span
      >
  </label> </p>
    <i class="material-icons-outlined right" :class="[fieldValue ? 'green-text text-accent-3' : 'grey-text text-darken-3']">task_alt</i>
  </div>
  <div class="clear"></div>
</div>
</div>
</template>

<script>
export default {
  name: "CompleteField",
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    name: {
      type: String,
      required: true,
    },
    sectionName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      fieldValue: this.value,
    };
  },
  mounted() {},
  watch: {
    fieldValue: function() {
      this.updateValue();
    },
  },

  methods: {
    updateValue(event) {
      this.$emit("update", this.fieldValue);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
